import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import { t } from '../../i18n';

export class MmResources extends Component {

    componentWillUnmount() {
        console.log("unmount");
    }

    render() {
        console.log("loading spinner");
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'mmResources'}
            title={ t('support.procedure.P2.title') }
            exportTitle={ t('support.procedure.P2.exportTitle') }
            exportFileName={'mm_resources.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (MmResources);